/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {ClassifiedListWrapper} from '../../modules/classified-module/ClassifiedList'

const ClassifiedPage: FC = () => {
  const breadcrum: Array<PageLink> = [
    {
      title: 'Classified Module',
      path: '/classified-module',
      isSeparator: false,
      isActive: false,
    },
  ]
  return (
    <>
      <PageTitle breadcrumbs={breadcrum}>Classified List</PageTitle>
      <ClassifiedListWrapper />
    </>
  )
}

export {ClassifiedPage}
